<template>
  <div class="video-detail">
    <JumpHeader />
    <video
      class="video-class"
      playsinline
      webkit-playsinline
      ref="videoRef"
      @click="changePlay"
      @ended="videoEnd"
      @canplay="videoCanPlay"
      @timeupdate="videoTimeUpdate"
    ></video>
    <div class="play-icon" v-if="isPaused" @click="changePlay">
      <van-icon name="play" />
    </div>
    <div class="slide-wrapper">
      <van-slider
        v-model="sliderValue"
        bar-height="2px"
        active-color="#d93f30"
        inactive-color="#fff"
        button-size="12px"
        @drag-start="dragStart"
        @change="sliderChange"
      />
    </div>
    <div class="right-tools">
      <div class="tool-item" @click="failToast">
        <van-icon name="browsing-history" size="30px" />
        <span>{{ detail.clickSum ? filterNum(detail.clickSum) : 0 }}</span>
      </div>
      <div class="tool-item" @click="failToast">
        <van-icon name="like" size="30px" />
        <span>{{ detail.praiseSum ? filterNum(detail.praiseSum) : 0 }}</span>
      </div>
      <div class="tool-item" @click="failToast">
        <van-icon name="chat" size="30px" />
        <span>{{ filterNum(commentCount) }}</span>
      </div>
      <div class="tool-item" @click="failToast">
        <van-icon name="share" size="30px" />
        <span>{{ detail.shareSum ? filterNum(detail.shareSum) : 0 }}</span>
      </div>
    </div>
    <div class="left-info">
      <div class="account">
        <img class="img-class" :src="detail.publishPic" alt="" />
        <div class="focus" @click="failToast">关注</div>
      </div>
      <div class="collection-name">
        <van-icon name="bars" size="20px" /><span>{{ detail.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import wxSdk from "@/http/wxApi.js";
import { Toast } from "vant";
import { getMobilsInfo } from "@/utils";
import JumpHeader from "@/components/Base/JumpHeader";
import { getVideoById, getCommentCount, clickRecord } from "@/http/api";
import ZMYDataCollection from "@/utils/zmy.js";

let _curTime = 0;

export default {
  name: "VideoDetail",
  components: {
    JumpHeader,
  },
  data() {
    return {
      id: null,
      detail: {},
      isPaused: true,
      commentCount: 0,
      sliderValue: 0,
      duration: 0,
      isDrag: false,
    };
  },
  mounted() {
    if(window.location.href.indexOf("share.gztv.com")){
      window.location.href=window.location.href.replace("share.gztv.com","app.gztv.com");
    }
    this.id = this.$route.query.id;
    this.getDetail();
    this.recordData();
    this.queryCommentCount();
    ZMYDataCollection.init({tenant_code:"prod-gzgb-6b45b19f05d3b092013fd6",key:"wJT7EOgGmpHClezJ2qgb1nE60RgVUnrX",domain:"rmapi.nfzmy.com",debug:"false"});
  },
  methods: {
    async getDetail() {
      const { data } = await getVideoById({ id: this.id });
      console.log(data);
      if (data) {
        this.detail = data;
        this.wxShare();
        this.$refs.videoRef.src = this.detail.videoUrl;
        this.$nextTick(() => {
          this.$refs.videoRef.poster = this.detail.pictureUrl;
        });
        if (this.$refs.videoRef.paused) {
          this.isPaused = true;
        } else {
          this.isPaused = false;
        }
        document.title = this.detail.name ? this.detail.name : "花城+";
        ZMYDataCollection.openArticle({article_id:this.id,platform:"Mobile"});
      }
    },
    async recordData() {
      await clickRecord({
        deviceId: "1",
        operateId: this.id,
        operateType: 2,
        web:1,
      });
    },
    async queryCommentCount() {
      const { data } = await getCommentCount({
        operateId: this.id,
        operateType: 2,
      });
      this.commentCount = data;
    },
    changePlay() {
      console.log(this.$refs.videoRef.paused);
      if (this.$refs.videoRef.paused) {
        this.$refs.videoRef.play();
        this.isPaused = false;
      } else {
        this.$refs.videoRef.pause();
        this.isPaused = true;
      }
    },
    failToast() {
      Toast.fail("请先下载APP");
    },
    filterNum(val) {
      if (val < 10000) {
        return val;
      } else {
        return `${(val / 10000).toFixed(2)}万`;
      }
    },
    wxShare() {
      const _detail = this.detail;
      wxSdk.getJSSDK({
        title: _detail.name,
        desc: "花城+",
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/videoDetail?id=${_detail.id}`,
        img: _detail.pictureUrl,
        operateId: this.id,
        operateType: 2,
      });
    },
    videoEnd() {
      this.isPaused = true;
    },
    videoCanPlay() {
      console.log(this.$refs.videoRef.duration);
      this.duration = this.$refs.videoRef.duration;
    },
    videoTimeUpdate() {
      // console.log(e);
      if (!this.isDrag) {
        let time = parseInt(this.$refs.videoRef.currentTime);
        if (time != _curTime) {
          _curTime = time;
          this.sliderValue = Math.ceil((_curTime / this.duration) * 100);
          console.log(this.sliderValue);
        }
      }
    },
    sliderChange(value) {
      this.isDrag = false;
      let sliderTime = Math.ceil((value / 100) * this.duration);
      this.$refs.videoRef.currentTime = sliderTime;
    },
    dragStart() {
      this.isDrag = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.video-detail {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000;

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 50px;
    color: #ccc;
  }

  .video-class {
    width: 100%;
    height: 100%;
  }

  .slide-wrapper {
    position: absolute;
    bottom: 50px;
    left: 20px;
    right: 20px;
  }

  .right-tools {
    position: absolute;
    right: 10px;
    bottom: 70px;
    width: 50px;
    height: 280px;

    .tool-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 70px;
      color: #fff;

      & > span {
        display: inline-block;
        font-size: 14px;
        margin-top: 3px;
      }
    }
  }

  .left-info {
    position: absolute;
    bottom: 90px;
    left: 20px;

    .account {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .img-class {
        width: 35px;
        height: 35px;
        border-radius: 50%;
      }
      .focus {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffffd9;
        font-size: 14px;
        width: 50px;
        height: 20px;
        border: 1px solid #ffffffd9;
        border-radius: 15px;
        margin-left: 15px;
      }
    }

    .title {
      font-size: 16px;
      color: #fff;
      margin: 10px 0;
    }

    .date {
      color: #ffffffa6;
      font-size: 14px;
      margin-bottom: 10px;
    }

    .collection-name {
      display: flex;
      align-items: center;
      color: #fff;

      & > span {
        font-size: 14px;
        margin-left: 3px;
      }
    }
  }
}
</style>
